import React from "react";
import { Grow, Popper } from "@mui/material";

const HyroPopper = ({
  anchorEl,
  placement = "top",
  zIndex = 1000,
  children
}) => (
  <Popper
    open={!!anchorEl}
    anchorEl={anchorEl}
    sx={{ zIndex }}
    placement={placement}
    transition
    modifiers={[
      {
        name: "offset",
        options: {
          offset: [0, 4]
        },
      }
    ]}
  >
    {({ TransitionProps }) => (
      <Grow {...TransitionProps}>
        {children}
      </Grow>
    )}
  </Popper>
);

export default HyroPopper;
